module.exports = __webpack_public_path__ + "static/img/channel-2.3916fa80.png";